export default ($axios) => (resource) => ({
	fetchEntities() {
		return $axios.get(`${resource}/user/authorizedentities`)
	},
})
